import { Component } from '@angular/core';

@Component({
  selector: 'app-resumetemplates',
  templateUrl: './resumetemplates.component.html',
  styleUrls: ['./resumetemplates.component.scss']
})
export class ResumetemplatesComponent {

}
